export default __webpack_public_path__ + "static/media/Bold.77b115a6.ttf";